import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { userSlice } from "../redux/user/userSlice";

const { showDialog } = userSlice;

export default function ProjectDeleteSection({ label = "проект" }) {
  const dispatch = useDispatch();

  return (
    <div className="app-editor-settings__access-wrap app-editor-settings__access-wrap--danger">
      <section className="app-settings-card app-settings-card--danger">
      <h3 className="app-settings-card__title app-settings-card__title--left">
        Удаление
      </h3>
      <p className="app-settings-danger__text">
        {label} и все связанные файлы будут удалены без возможности восстановления.
      </p>
      <Button
        variant="contained"
        color="error"
        size="small"
        className="app-settings-danger__btn"
        onClick={() => dispatch(showDialog("delete"))}
      >
        Удалить
      </Button>
      </section>
    </div>
  );
}
